import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SettingsComponent } from '@spaq/modules/settings/settings.component';
import { SharedCommonModule, SharedComponentsModule } from '@spaq/shared';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DialogWaitComponent, SettingsCardComponent } from './components';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
	imports: [SharedCommonModule, RouterModule, SharedComponentsModule, DialogsModule, DropDownsModule],
	declarations: [SettingsCardComponent, DialogWaitComponent, SettingsComponent],
	exports: [SettingsComponent, SettingsCardComponent, DialogWaitComponent],
	entryComponents: []
})
export class SettingsModule {}
